import { useTranslation } from 'react-i18next'
import { PulseLoader } from 'react-spinners'

export const LoadingCom = ({ className = '', height }) => {
  const { t } = useTranslation()
  return (
    <div
      className={`flex flex-col items-center justify-center gap-8 text-center ${className} relative`}
      style={height ? { height: `${height}px` } : undefined}
    >
      <PulseLoader
        color="#1C50B9"
        margin={10}
        size={10}
        speedMultiplier={1}
        className="absolute top-1/2 left-1/2 z-8 -translate-1/2"
        aria-label={t('common.loading')}
        data-testid="loader"
      />
      <span className={'mt-64 block'}>{t('common.loading')}</span>
    </div>
  )
}
